/*
 * @Description: 请输入....
 * @Author: zyk
 * @Date: 2021-01-24 17:40:42
 * @LastEditTime: 2021-01-24 17:50:32
 * @LastEditors: zyk
 */
import styled from 'styled-components';


export const Wrap = styled.div`
  position:fixed;
  top:0;
  width:100%;
  height: 100%;
  background: rgba(0, 0, 0, .8);
  z-index: 99999;
  header{
    width: 70%;
    position:absolute;
    left:50%;
    top:40%;
    transform:translate(-50%,-50%);
  }



`